exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plain-text-tabs .sb-base-table .v-table__overflow{max-height:calc(100vh - 384px)}.plain-text-tabs .layout{margin-top:0px !important}\n", ""]);

// exports
